module.exports = __webpack_public_path__ + "static/media/brand_small_banner.941dfa3b.jpg";